const USER_ID = window.__PRELOADED_STATE__.currentAccount.id;

export const logPageView = () => {
  if (window.dataLayer) window.dataLayer.push({
    event: 'eventTracking',
    userId: USER_ID,
    category: 'Change page',
    action: `Current page: ${window.location.pathname}`,
    label: window.location.href + window.location.pathname
  });
};

export const sendEventToGTM = ({
  category,
  action,
  label,
  value = undefined,
  clanId = undefined
}) => {
  if (window.dataLayer) window.dataLayer.push({
    event: 'eventTracking',
    userId: USER_ID,
    category,
    action,
    label,
    value,
    clanId
  });
};